import React  from 'react';
import CurrencyComponentProto from './currency-proto.jsx';


export default function renderCurrencyInEdit(id, props) {
    return <CurrencyComponentProto renderMode="edit" id={id} {...props} />;
}